import React, { useCallback, useEffect, useState } from 'react'

import Button from 'components_new/atoms/Button'
import Text from 'components_new/atoms/Text'

import SidebarDialog from 'components_new/molecules/SidebarDialog'

import { useTranslation } from 'language/translator'

interface UnlinkDialogProps {
  onClose: () => void
  onUnlink: (callback: () => void) => void
  open: boolean
  source: string
  title: string
  type: string
}

const UnlinkDialog = (props: UnlinkDialogProps) => {
  const { onClose, onUnlink, open, source, title, type } = props

  const [loading, setLoading] = useState(false)

  const { lang, t } = useTranslation()

  const handleClose = () => {
    setLoading(false)
    onClose()
  }

  const handleUnlink = useCallback(() => {
    setLoading(true)
    onUnlink(() => setLoading(false))
  }, [onUnlink])

  useEffect(() => {
    if (!open) return

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        handleUnlink()
      }
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [open, handleUnlink])

  return (
    <SidebarDialog
      actions={
        <>
          <Button variant="text" onClick={handleClose}>
            {t('global', 'cancel')}
          </Button>
          <Button loading={loading} onClick={handleUnlink}>
            {t('global', 'unlink')}
          </Button>
        </>
      }
      maxWidth="xs"
      open={open}
      onClose={onClose}
      title={`${t('global', 'unlink')}${
        lang === 'sv' ? ` ${t('global', 'of', true)} ` : ' '
      }${type.toLowerCase()}?`}
    >
      <Text color="text.primary">
        <b>{title}</b> {t('global', 'will_be_unlinked_from')} <b>{source}</b>.
      </Text>
    </SidebarDialog>
  )
}

export default UnlinkDialog
